import { ReferralsHttpAdapter } from '~/services/adapters/referrals.adapter';

export class ReferralsService extends ReferralsHttpAdapter {}
